<template>
  <div class="file-item">
    <div class="title">
      <div
        style="
          display: flex;
          align-items: center;
          position: relative;
          color: #1890ff;
          flex-grow: 1;
          overflow: hidden;
        "
        @click="handleClick"
      >
        <a-icon type="paper-clip-outlined"></a-icon>
        <span
          style="
            position: relative;
            max-width: 90%;
            display: inline-block;
            margin-left: 10px;
            white-space: nowrap; /* 确保文本在一行内显示 */
            overflow: hidden; /* 隐藏超出容器的文本 */
            text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
          "
          >{{ props.value.fileName }}</span
        >
      </div>
      <div style="width: auto; display: inline-flex; margin-left: 5px; font-size: 18px">
        <span
          class="download-icon"
          v-if="showDownload && value.status === 'uploaded'"
          @click="handleDownload($event, value)"
        >
        </span>
        <!-- <LoadingIcon v-if="value.status === 'uploading'" class="icon-loading"></LoadingIcon> -->
        <span
          class="close-icon"
          style="display: flex; align-items: center"
          @click="handleDelete"
          v-if="value.status === 'uploaded'"
        >
        </span>
      </div>
    </div>
    <div
      class="progress"
      v-if="props.value.status === 'uploading' && props.value.progress"
    >
      <a-progress :percent="props.value.progress" :showInfo="false" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { defineProps, onMounted, defineEmits } from "vue";
import { urlToBold } from "./utils";
import { message } from "ant-design-vue";
import aIcon from "@/components/aicon/aicon.vue";
// import LoadingIcon from "./BaseUpload/svg-icon/loadingIcon.vue";
// import CloseIcon from "./BaseUpload/svg-icon/closeIcon.vue";
// import DownloadIcon from "./BaseUpload/svg-icon/downloadIcon.vue";
// import DownloadIconHover from "./BaseUpload/svg-icon/downloadIconHover.vue";
// import CloseIconHover from "./BaseUpload/svg-icon/closeIconHover.vue";
const props = defineProps(["value", "index", "showDownload"]);
const emit = defineEmits(["delete", "click"]);
// const isHover = ref(false);
// const isCloseHover = ref(false);

// const statusConfig: any = {
//   uploadFailed: {
//     color: "red",
//     iconType: "info-circle-outlined",
//   },
//   uploading: {
//     color: "orange",
//     iconType: "clock-circle-outlined",
//   },
//   uploaded: {
//     color: "green",
//     iconType: "check-circle-outlined",
//   },
//   notUploaded: {
//     color: "#555",
//     iconType: "pause-circle-outlined",
//   },
// };
function handleDelete() {
  emit("delete", { value: props.value, index: props.index });
}
function handleClick() {
  emit("click", { value: props.value, index: props.index });
}
// function handleMousemove() {
//   isHover.value = true;
//   // alert("移入");
// }
// function handleMouseleave() {
//   isHover.value = false;
//   // alert("移出");
// }

// function handleCloseMousemove() {
//   isCloseHover.value = true;
// }
// function handleCloseMouseleave() {
//   isCloseHover.value = false;
// }
async function handleDownload(e: any, value: any) {
  e.stopPropagation();
  if (value.status == "uploaded") {
    const result: any = await urlToBold(value.fileUrl);
    if (!result.success) {
      message.warning(result.msg);
      return;
    }
    let eleLink = document.createElement("a");
    eleLink.download = value.fileName;
    eleLink.style.display = "none";
    eleLink.href = URL.createObjectURL(result.blob);
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
  }
}
onMounted(() => {
  // console.log(props, "props");
});
</script>
<style lang="scss" space>
@keyframes loading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.status-icon {
  position: relative;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.file-item .title {
  position: relative;
  font-size: 16px;
  display: flex;
  width: 100%;
  margin-left: 0px;
  align-items: center;
  justify-content: space-between;
}

.file-item .title span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  //   color: #1890ff;
  cursor: pointer;
  display: inline-block;
}
.file-item .download-icon {
  position: relative;
  fill: #ea9518;
  display: inline-block;
  width: 18px;
  height: 18px;
  background-size: contain;
  margin-right: 8px;
  background-image: url("../../assets/icon/download.png");
}
.file-item .download-icon:hover {
  position: relative;
  background-image: url("../../assets/icon/download_hover.png");
}

.file-item .icon-loading {
  position: relative;
  animation: loading 0.5s linear infinite;
}

.file-item .close-icon {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  background-size: contain;
  background-image: url("../../assets/icon/close.png");
}
.file-item .close-icon:hover {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  background-image: url("../../assets/icon/close_hover.png");
}
</style>
